var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeveloping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 1h-13c-3.033 0-5.5 2.467-5.5 5.5v11c0 3.032 2.468 5.5 5.5 5.5h13c3.032 0 5.5-2.468 5.5-5.5v-11c0-3.033-2.468-5.5-5.5-5.5zm-9 2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-5 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm16.5 14.5c0 1.379-1.121 2.5-2.5 2.5h-13c-1.379 0-2.5-1.121-2.5-2.5v-9.5h18zm-14.176-1.489c-.539-.537-.824-1.225-.824-1.956s.285-1.419.803-1.936l1.68-1.68c.586-.586 1.535-.586 2.121 0s.586 1.535 0 2.121l-1.49 1.49 1.425 1.367c.599.573.618 1.522.044 2.12-.573.599-1.525.617-2.12.044l-1.638-1.571zm6.572-3.45c-.586-.586-.586-1.535 0-2.121s1.535-.586 2.121 0l1.681 1.681c.517.516.802 1.203.802 1.935s-.285 1.419-.803 1.936l-1.659 1.592c-.595.573-1.548.555-2.12-.044-.574-.598-.555-1.547.044-2.12l1.425-1.367-1.49-1.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloping);
export default __webpack_public_path__ + "static/media/developing.42496df968cf529e996338e0c9ede689.svg";
export { ForwardRef as ReactComponent };